import { render, staticRenderFns } from "./PpeApplyRecordHistoryEdit.vue?vue&type=template&id=6c5ba371&"
import script from "./PpeApplyRecordHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports